import { createSlice } from '@reduxjs/toolkit'
import CemeteryHome from '../new_version/pages/pagesHome/CemeteryHome';
import BlockHome from '../new_version/pages/pagesHome/BlockHome';
import PlotHome from '../new_version/pages/pagesHome/PlotHome';
import AreaGraveHome from '../new_version/pages/pagesHome/AreaGraveHome';
import PurchasesHome from '../new_version/pages/pagesHome/PurchasesHome';
import BurialsHome from '../new_version/pages/pagesHome/BurialsHome';
import CustomersHome from '../new_version/pages/pagesHome/CustomersHome';

  // עמודות לטבלת בתי עלמין
  export const recordsOptionsSlice = createSlice({
    name: 'recordsOptions',
    initialState: { data: [
     { id: 0, permissions: [1,2,3,4,5], label: 'כל הרשומות' },
     { id: 1, permissions: [1,2,3,4,5], label: 'רכישות', component: <PurchasesHome /> },
     { id: 2, permissions: [1,2,3,4,5], label: 'קבורות', component: <BurialsHome /> },
     { id: 3, permissions: [1,2,3,4,5], label: 'לקוחות', component: <CustomersHome /> },
     { id: 4, permissions: [1], label: 'בתי עלמין', component: <CemeteryHome /> },
     { id: 5, permissions: [1], label: 'גושים', component: <BlockHome /> },
     { id: 6, permissions: [1], label: 'חלקות', component: <PlotHome /> },
     { id: 7, permissions: [1], label: 'קברים', component: <AreaGraveHome /> },
   ] },
    reducers: {
      setData(state, action) {
        state.data = action.payload;
      },
    },
  })
  
  export const categoryCitiesActions = recordsOptionsSlice.actions
